import { render, staticRenderFns } from "./WxCouponStock.vue?vue&type=template&id=1d696767&scoped=true"
import script from "./WxCouponStock.vue?vue&type=script&lang=js"
export * from "./WxCouponStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d696767",
  null
  
)

export default component.exports